<template>
  <div ref="mychart" :style="{ widith: '100%', height: computedHeight }"></div>
</template>

<script>
export default {
  props: {
    options: {
      type: Object,
      default: null,
    },
    height: {
      type: [Number, String],
      default: "100%",
    },
  },
  computed: {
    computedHeight() {
      switch (typeof this.height) {
        case "string":
          if (+this.height == this.height) return `${this.height / 20}rem`;
          return this.height;

        case "number":
          return `${this.height / 20}rem`;

        default:
          return `${1 / 20}rem`;
      }
    },
  },
  mounted() {
    this.chart = this.$echarts.init(this.$refs.mychart);
    this.onResize = this.onResize.bind(this);
    // console.log("mounted refs", this.$refs, this.chart);
    window.addEventListener("resize", this.onResize);
  },
  destroyed() {
    window.removeEventListener("resize", this.onResize);
    this.chart?.dispose();
  },

  watch: {
    options: {
      handler(options) {
        this.update(options);
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    onResize() {
      this.chart?.resize();
    },
    update(options) {
      this._options = Object.assign(this._options || {}, options);
      // console.log("options", this._options);
      this.chart?.setOption(this._options);
    },
  },
};
</script>

<style lang="less" scoped></style>
